<template>
    <div class="section-result">
        <div class="section-result__body">
            <div class="section-result__content-box">
                <div class="section-result__title" v-html="title"></div>
                <div class="section-result__desc" v-html="content"></div>
            </div>

            <div class="section-result__map-box">
                <section-map class="section-result__map" hide-events />
            </div>

            <div class="section-result__share-box">
                <a :href="$store.state.links.ebay" target="_blank" class="section-result__ebay-btn border theme-light ui-btn">Начать продавать за границей</a>
                <block-share class="section-result__share" :url="share" />
                <button class="section-result__btn" @click="onReplay">Еще раз</button>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapState, mapActions} from 'vuex'

    export default {
        components: {},
        computed: {
            ...mapState(['game']),
            title () {
                if (this.game === 'win') {
                    return `Вы – повелитель экспорта!`
                } else {
                    return `О, нет! <br />С экспортом ушей Йоды и боли Гарольда в этот раз не получилось.`
                }
            },
            content () {
                if (this.game === 'win') {
                    return `
                        Преклоняемся перед вашими способностями и поздравляем вас с захватом планеты, в вас кроется гениальный предприниматель.
                        Так не медлите же и <a href="https://pikabu.ru/story/_vastauzhskooroskoepaitsotaekdogo_alvo__aysle_3876093" target="_blank">присоединяйтесь к 30 000</a> продавцов eBay из России.
                        А чтобы быстрее завоевать мировой рынок в реальности, узнайте, как
                        <a href="https://pikabu.ru/story/_vasta_seskosskoroehct__otaekdogo_alvo_vog_al_3876093" target="_blank">настроить аккаунт</a> и
                        <a href="https://pikabu.ru/story/bubm_r_chceq_zamoyonnozva_beniobre_sv_t_zafps_3876093" target="_blank">начать продажи.</a>
                    `
                } else {
                    return `
                       Возможно, виноват високосный год.
                       Но, скорее всего, наша игра — просто не ваш масштаб.
                       Попробуйте себя в реальном экспорте и <a href="https://pikabu.ru/story/_vastauzhskooroskoepaitsotaekdogo_alvo__aysle_3876093" target="_blank">присоединяйтесь к 30 000</a> российских продавцов eBay.
                       А чтобы сделать бизнес за границей было проще, узнайте, как
                       <a href="https://pikabu.ru/story/_vasta_seskosskoroehct__otaekdogo_alvo_vog_al_3876093" target="_blank">настроить аккаунт</a> и
                       <a href="https://pikabu.ru/story/bubm_r_chceq_zamoyonnozva_beniobre_sv_t_zafps_3876093" target="_blank">начать продажи.</a>
                    `
                }
            },
            share () {
                if (this.game === 'win') {
                    return 'https://specials.pikabu.ru/ebay/game/wshare.html'
                } else {
                    return 'https://specials.pikabu.ru/ebay/game/lshare.html'
                }
            }
        },
        methods: {
            ...mapActions('control', ['stop']),

            onReplay () {
                this.$router.push({name: 'hello'})
                setTimeout(() => {
                    this.stop()
                }, 600)
            }
        }
    }
</script>

<style lang="stylus" scoped>
    .section-result {
        padding 0 4rem 0 6.3rem
        +layout-sm() {
            padding 0 6.3rem 0 6.3rem
        }
        +layout-xs() {
            padding 0 2rem
        }

        &__body {
            padding 0 0 6.3rem 0
            grid-template-columns 1fr 47rem
            grid-template-rows auto auto
            display grid
            align-items start
            @media (max-width: 894px) {
                grid-template-columns 45% 1fr
            }
            +layout-sm() {
                border-top 0.1rem solid #2B0EAF
                grid-auto-columns column
                grid-template-columns 1fr

            }
            +layout-xs() {
                padding 0 0 2rem 0
            }
        }

        &__content-box {
            grid-row 1 / -1
            +layout-sm() {
                grid-row auto
            }
        }

        &__share-box {
            margin-top 3rem
            padding-left 14.9rem
            padding-right 3.8rem
            display flex
            justify-content space-between
            flex-wrap wrap
            align-items flex-start
            @media (max-width: 894px) {
                padding 0 0 0 3rem
            }
            +layout-sm() {
                padding-left: 0
                max-width 64rem
                margin-left auto
                margin-right auto
            }
            +layout-xs() {
                max-width 100%
                margin 2.3rem 0 0 0
            }
        }

        &__map-box {
            +layout-sm() {
                order -1
            }
            +layout-xs() {
                margin-left -2rem
                margin-right -2rem
            }
        }

        &__title {
            margin-top 2.3rem
            font-size 3.4rem
            line-height 4.1rem
            font-weight $font-bold
            @media (max-width: 894px) {
                font-size 2.3rem
                line-height 2.8rem
            }
            +layout-sm() {
                text-align center
            }
            +layout-xs() {
                margin-top 2.7rem
                text-align left
            }
        }

        &__desc {
            margin-top 1.3rem
            font-size 1.7rem
            line-height 2.4rem
            @media (max-width: 894px) {
                font-size 1.8rem
                line-height 1.2
            }
            +layout-sm() {
                font-size 1.5rem
            }
            >>> a {
                color #fff
                font-weight $font-bold
            }
        }

        &__ebay-btn {
            width 100%
            font-size 1.5rem
            font-weight $font-bold
            margin-bottom 2.3rem
            padding 0
            border-width 0.7rem
            min-height 5.7rem
            +layout-xs() {
                margin-bottom 1.7rem
            }
        }

        &__share {
            height 3.7rem
            display flex
            align-items center
        }

        &__btn {
            width 9.6rem
            height 3.7rem
            background-color $color-accent
            font-size 1.5rem
            display inline-flex
            justify-content center
            align-items center
            color #2B0EAF
            cursor pointer
            padding 0
            outline 0
            border 0 none
            user-select none
            transition background-color 0.3s ease, border-color 0.3s ease

            &:hover {
                background-color #629CFF
                border-color #629CFF
            }

            &:active {
                opacity 0.9
            }
        }

        &__map {
            margin 4.6rem 0 0 0
        }
    }
</style>
